import { render, staticRenderFns } from "./cognizanceManage.vue?vue&type=template&id=2d873c6e&"
import script from "./cognizanceManage.vue?vue&type=script&lang=js&"
export * from "./cognizanceManage.vue?vue&type=script&lang=js&"
import style0 from "./cognizanceManage.vue?vue&type=style&index=0&id=2d873c6e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports